var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.63 3.45753C15.2469 3.07428 14.7921 2.77026 14.2915 2.56284C13.7909 2.35542 13.2543 2.24866 12.7125 2.24866C12.1706 2.24866 11.634 2.35542 11.1335 2.56284C10.6329 2.77026 10.178 3.07428 9.79497 3.45753L8.99997 4.25253L8.20497 3.45753C7.4312 2.68376 6.38174 2.24906 5.28747 2.24906C4.19319 2.24906 3.14374 2.68376 2.36997 3.45753C1.5962 4.2313 1.1615 5.28075 1.1615 6.37503C1.1615 7.4693 1.5962 8.51876 2.36997 9.29253L3.16497 10.0875L8.99997 15.9225L14.835 10.0875L15.63 9.29253C16.0132 8.90946 16.3172 8.45464 16.5247 7.95404C16.7321 7.45345 16.8388 6.91689 16.8388 6.37503C16.8388 5.83316 16.7321 5.2966 16.5247 4.79601C16.3172 4.29542 16.0132 3.84059 15.63 3.45753V3.45753Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ae8add48a6779570dd424b038368fd4e.svg";
export { ForwardRef as ReactComponent };